// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1j0fE","content":"LayoutSettings_content__1aJfr"};